import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Title from "@streeteasy/design-system/deprecated/Title";

const Link = styled(Title).attrs({
  as: "a",
  type: "secondarySmCaps"
})`
  color: ${colors.primary};
  cursor: pointer;
`;

export { Link };
